module.exports = __webpack_public_path__ + "img/under_construction-min.46cdc3a5.png";